import { ChallengeActionType } from '~app/modules/checkout/models';
import { PaymentState } from '~app/modules/checkout/store/payment/payment.state';
import { PaymentActions, PaymentActionTypes } from './payment.actions';

export const initialState: PaymentState = {
  payload: null,
  loading: false,
  error: null,
};

export function reducer(state = initialState, action: PaymentActions): PaymentState {
  switch (action.type) {
    case PaymentActionTypes.INIT_PAYMENT:
    case PaymentActionTypes.MAKE_PAYMENT:
    case PaymentActionTypes.ADYEN_3DS_DETAILS:
    case PaymentActionTypes.PAYPAL_DETAILS:
    case PaymentActionTypes.SOFORT_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PaymentActionTypes.CANCEL_ADYEN_3DS_FLOW:
    case PaymentActionTypes.CANCEL_PAYPAL_FLOW:
    case PaymentActionTypes.INIT_PAYPAL_FLOW:
    case PaymentActionTypes.CANCEL_SOFORT_FLOW:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case PaymentActionTypes.INIT_ADYEN_3DS_FLOW:
    case PaymentActionTypes.INIT_SOFORT_FLOW:
      return {
        ...state,
        loading: action.payload.challengeResponse.action.type === ChallengeActionType.Redirect ? false : state.loading,
        error: null,
      };

    case PaymentActionTypes.INIT_PAYMENT_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          paymentWidget: action.payload.paymentWidgetConfig,
          lastPaymentMethodUsed: action.payload.lastPaymentMethodUsed,
        },
        loading: false,
        error: null,
      };

    case PaymentActionTypes.INIT_PAYMENT_FAILURE:
      return {
        payload: null,
        loading: false,
        error: action.payload.error,
      };

    case PaymentActionTypes.MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          payment: action.payload.payment,
        },
        loading: false,
      };

    case PaymentActionTypes.MAKE_PAYMENT_FAILURE:
      return {
        payload: {
          ...state.payload,
          payment: null,
          paymentWidget: action.payload.error.availablePaymentMethods,
        },
        loading: false,
        error: action.payload.error,
      };

    case PaymentActionTypes.MAKE_PAYMENT_OTHER_FAILURE:
      return {
        payload: {
          ...state.payload,
          payment: null,
        },
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
